import { useEffect, useState } from "react";
import api from "./api";

export const useSiteSettings = () => {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => setSettings(null));
  }, []);
  return settings;
};
